import { render, staticRenderFns } from "./ActionRechazoAdministrativo.vue?vue&type=template&id=8ad3f2f8&lang=pug"
import script from "./ActionRechazoAdministrativo.vue?vue&type=script&lang=js"
export * from "./ActionRechazoAdministrativo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports